export enum SpirometryAnalysisSetTypeEnum {
	Overread = "SAS_OVERREAD",
	QC = "SAS_QC",
	Site = "SAS_SITE",
}